<!--
 * @Descripttion:
 * @version:
 * @Author: yzf
 * @Date: 2020-09-09 14:45:37
 * @LastEditors: yzf
 * @LastEditTime: 2020-10-09 10:34:09
-->
<template>
  <div class="nlp-wrap" v-if="nlpShow">
    <div class="nlp-start" :class="{ show: !active }" @click="start">
      <a-icon type="android" />
    </div>
    <div class="nlp-content" :class="{ show: active }">
      <div class="head">
        <div class="close" @click="stop">
          <a-icon type="close" />
        </div>
      </div>
      <div class="content" :class="{ long: list.length > 2 }">
        <div class="title" v-if="!list.length">您好,请问需要什么帮助?</div>
        <div class="says" v-else ref='says'>
          <div
            v-for="(item, i) in list"
            :key="i"
            :class="{
              answer: item.type === 'answer',
              say: item.type !== 'answer'
            }"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="donig" @click="changeRecorder">
          <a-icon type="notification" :class="{ active: recording }"/>
        </div>
        <div class="inp">
          <input type="text" v-model="say" @keydown.enter="entry" />
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import tts from '../../../utils/tts.js'
const CryptoJS = require('crypto-js')
var transWorker = new Worker(`${window.location.origin}/webworker/transcode.worker.js`)
export default {
  name: 'nlp',
  vuex: {
    getters: {
      projectInfo: state => state.project.info,
      appInfo: state => state.app.appInfo,
      pageInfo: state => state.page.pageInfo
    }
  },
  data () {
    return {
      // 所有输入输出的列表
      list: [],
      // 当前正在输入的
      say: '',
      resultTextTemp: '',
      // 整体当前是否打开
      active: false,
      // 当前是否正在录入
      recording: false,
      // websocket对象,用来进行socket连接的处理
      webSocket: {},
      // webworker对象,用来开启另一个线程处理音频
      transWorker: {},
      // 个人信息,在讯飞控制台获取
      APPID: '5f1280b6',
      API_SECRET: '3467315e7f5ce3e8af3e3c93f07cdd52',
      API_KEY: 'c83824b9edbdd04c8d54c5f72ddc0fb5',
      // 音频录制状态
      status: '',
      // 配置项,默认就可以
      language: 'zh_cn',
      accent: 'mandarin',
      // 记录音频数据
      audioData: [],
      // 音频环境
      audioContext: '',
      // MediaStreamAudioSourceNode 对象，使来自MediaStream的音频可以被播放和操作
      mediaSource: '',
      // 创建一个audioNode用于通过JavaScript直接处理音频
      scriptProcessor: '',
      // 判断socket是否连接完成的定时器
      handlerInterval: '',
      // 判断说话停止时间
      recordTime: {},
      // 多轮对话id
      sessionId: 0,
      // 临时处理显示隐藏
      nlpShow: false
    }
  },
  methods: {
    start () {
      this.active = true
      tts.say('您好,请问需要什么帮助?')
      // this.recorderStart()
    },
    stop () {
      this.active = false
      this.list = []
      this.say = ''
      this.resultTextTemp = ''
      this.sessionId++
      tts.close()
      this.recorderStop()
    },
    changeRecorder () {
      this.recording = !this.recording
      this.recording ? this.recorderStart() : this.recorderStop()
    },
    // 打开录音
    recorderStart () {
      // 判断是否已经获取过录音设备
      if (!this.audioContext) {
        this.recorderInit()
      } else {
        this.audioContext.resume()
        this.connectWebSocket()
      }
      this.recording = true
      tts.close()
    },
    // 暂停录音
    recorderStop (isClose) {
      // safari下suspend后再次resume录音内容将是空白，设置safari下不做suspend
      if (
        !(
          /Safari/.test(navigator.userAgent) &&
          !/Chrome/.test(navigator.userAgen)
        )
      ) {
        this.audioContext && this.audioContext.suspend()
      }
      if (!isClose) {
        this.recording = false
      }
      this.closeWebsocket()
      this.setStatus('end')
    },
    // 修改录音听写状态
    setStatus (status) {
      this.onWillStatusChange &&
        this.status !== status &&
        this.onWillStatusChange(this.status, status)
      this.status = status
    },
    // 处理状态改变的情况
    onWillStatusChange (oldStatus, status) {
      console.log('onWillStatusChange', status)
    },
    // 初始化浏览器录音
    recorderInit () {
      // 兼容getUserMedia
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia

      // 创建音频环境
      try {
        this.audioContext = new (window.AudioContext ||
          window.webkitAudioContext)()
        this.audioContext.resume()
        if (!this.audioContext) {
          alert('浏览器不支持webAudioApi相关接口')
          return
        }
      } catch (e) {
        if (!this.audioContext) {
          alert('浏览器不支持webAudioApi相关接口')
          return
        }
      }

      // 判断设备支持的api获取浏览器录音权限
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            audio: true,
            video: false
          })
          .then(stream => {
            this.getMediaSuccess(stream)
          })
          .catch(e => {
            this.getMediaFail(e)
          })
      } else if (navigator.getUserMedia) {
        navigator.getUserMedia(
          {
            audio: true,
            video: false
          },
          stream => {
            this.getMediaSuccess(stream)
          },
          function (e) {
            this.getMediaFail(e)
          }
        )
      } else {
        if (
          navigator.userAgent.toLowerCase().match(/chrome/) &&
          location.origin.indexOf('https://') < 0
        ) {
          alert(
            'chrome下获取浏览器录音功能，因为安全性问题，需要在localhost或127.0.0.1或https下才能获取权限'
          )
        } else {
          alert('无法获取浏览器录音功能，请升级浏览器或使用chrome')
        }
        this.audioContext && this.audioContext.close()
      }
    },
    // 获取设备成功
    getMediaSuccess (stream) {
      // 创建一个audioNode用于通过JavaScript直接处理音频
      this.scriptProcessor = this.audioContext.createScriptProcessor(0, 1, 1)
      this.scriptProcessor.onaudioprocess = e => {
        // 去处理音频数据
        if (this.status === 'ing') {
          this.transWorker.postMessage(e.inputBuffer.getChannelData(0))
        }
      }
      // 创建一个新的MediaStreamAudioSourceNode 对象，使来自MediaStream的音频可以被播放和操作
      this.mediaSource = this.audioContext.createMediaStreamSource(stream)
      // 连接
      this.mediaSource.connect(this.scriptProcessor)
      this.scriptProcessor.connect(this.audioContext.destination)
      this.connectWebSocket()
    },
    // 获取设备失败
    getMediaFail (e) {
      alert('请求麦克风失败')
      console.log(e)
      this.audioContext && this.audioContext.close()
      this.audioContext = undefined
      // 关闭websocket
      if (this.webSocket && this.webSocket.readyState === 1) {
        this.webSocket.close()
      }
    },
    // 拼接socket地址和鉴权参数
    getWebSocketUrl () {
      return new Promise((resolve, reject) => {
        // 请求地址根据语种不同变化
        var url = 'wss://iat-api.xfyun.cn/v2/iat'
        var host = 'iat-api.xfyun.cn'
        var apiKey = this.API_KEY
        var apiSecret = this.API_SECRET
        var date = new Date().toGMTString()
        var algorithm = 'hmac-sha256'
        var headers = 'host date request-line'
        var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`
        var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret)
        var signature = CryptoJS.enc.Base64.stringify(signatureSha)
        var authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`
        var authorization = btoa(authorizationOrigin)
        url = `${url}?authorization=${authorization}&date=${date}&host=${host}`
        resolve(url)
      })
    },
    // socket连接,事件绑定
    connectWebSocket () {
      return this.getWebSocketUrl().then(url => {
        let iatWS
        if ('WebSocket' in window) {
          iatWS = new WebSocket(url)
        } else if ('MozWebSocket' in window) {
          // eslint-disable-next-line no-undef
          iatWS = new MozWebSocket(url)
        } else {
          alert('浏览器不支持WebSocket')
          return
        }
        this.webSocket = iatWS
        this.setStatus('init')
        iatWS.onopen = e => {
          this.setStatus('ing')
          // 重新开始录音
          setTimeout(() => {
            this.webSocketSend()
          }, 100)
        }
        iatWS.onmessage = e => {
          this.result(e.data)
        }
        iatWS.onerror = e => {
          this.recorderStop()
        }
        iatWS.onclose = e => {
          this.recorderStop()
        }
      })
    },
    closeWebsocket () {
      this.webSocket.close()
    },
    // 得到了结果
    result (resultData) {
      let jsonData = JSON.parse(resultData)
      if (jsonData.data && jsonData.data.result) {
        clearTimeout(this.recordTime)
        let data = jsonData.data.result
        let str = ''
        let ws = data.ws
        for (let i = 0; i < ws.length; i++) {
          str = str + ws[i].cw[0].w
        }
        if (str === '。' || !str) {
          return
        }
        if (str === '关闭机器人') {
          this.stop()
          return
        }
        // 开启wpgs会有此字段(前提：在控制台开通动态修正功能)
        // 取值为 "apd"时表示该片结果是追加到前面的最终结果；取值为"rpl" 时表示替换前面的部分结果，替换范围为rg字段
        if (data.pgs) {
          if (data.pgs === 'apd') {
            // 将resultTextTemp同步给resultText
            this.setResultText({
              resultText: this.resultTextTemp
            })
          }
          // 将结果存储在resultTextTemp中
          this.setResultText({
            resultTextTemp: this.resultText + str
          })
        } else {
          this.setResultText({
            resultText: this.resultText + str
          })
        }
        this.recordTime = setTimeout(() => {
          this.entry(1)
        }, 1000)
      }
      if (jsonData.code === 0 && jsonData.data.status === 2) {
        this.recorderStop()
      }
      if (jsonData.code !== 0) {
        this.recorderStop()
        console.log(`${jsonData.code}:${jsonData.message}`)
      }
    },
    setResultText ({ resultText, resultTextTemp } = {}) {
      this.say = resultTextTemp || resultText || ''
      resultText !== undefined && (this.resultText = resultText)
      resultTextTemp !== undefined && (this.resultTextTemp = resultTextTemp)
    },
    entry (type) {
      clearTimeout(this.recordTime)
      if (this.say === '关闭语音输入') {
        this.recorderStop()
        this.list.push({
          type: 'say',
          text: this.say
        })
        this.list.push({
          type: 'answer',
          text: '语音输入已关闭'
        })
        this.saysScroll()
        this.say = ''
        this.resultTextTemp = ''
        return
      }
      this.recorderStop()
      const data = {
        say: this.say,
        sessionId: this.sessionId,
        projectId: this.$route.query && this.$route.query.project_id,
        appId: this.$route.query && this.$route.query.app_id,
        versionId: this.$route.query && this.$route.query.version_id
      }
      this.$post('api/chatbot/doSay', data)
        .then(res => {
          console.log('res', res)
          this.list.push({
            type: 'say',
            text: this.say
          })
          this.list.push({
            type: 'answer',
            text: res.say
          })
          tts.say(res.say)
          if (this.say === '打开编辑器') {
            // TODO:返回调用方法的处理
            const type = 'openEdit'
            this.$event.$emit(type)
          }
          if (this.say === '预览') {
            this.$event.$emit('goView')
          }
          if (res.list) {
            this.$event.$emit(res.intent, res.list)
          }
          this.saysScroll()
          this.say = ''
          this.resultTextTemp = ''
          if (type) {
            // this.recorderStart()
          }
        })
        .catch(req => {
          this.list.push({
            type: 'say',
            text: this.say
          })
          this.list.push({
            type: 'answer',
            text: '接口错误,请检查网络'
          })
          tts.say('接口错误,请检查网络')
          this.saysScroll()
          this.say = ''
          this.resultTextTemp = ''
          if (type) {
            // this.recorderStart()
          }
        })
    },
    saysScroll () {
      this.$nextTick(() => {
        this.$refs.says.scrollTo(0, 100000000)
      })
    },
    // 对处理后的音频数据进行base64编码，
    toBase64 (buffer) {
      var binary = ''
      var bytes = new Uint8Array(buffer)
      var len = bytes.byteLength
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    },
    // 向webSocket发送数据
    webSocketSend () {
      if (this.webSocket.readyState !== 1) {
        return
      }
      let audioData = this.audioData.splice(0, 1280)
      var params = {
        common: {
          app_id: this.APPID
        },
        business: {
          language: this.language, // 小语种可在控制台--语音听写（流式）--方言/语种处添加试用
          domain: 'iat',
          accent: this.accent, // 中文方言可在控制台--语音听写（流式）--方言/语种处添加试用
          vad_eos: 5000,
          dwa: 'wpgs' // 为使该功能生效，需到控制台开通动态修正功能（该功能免费）
        },
        data: {
          status: 0,
          format: 'audio/L16;rate=16000',
          encoding: 'raw',
          audio: this.toBase64(audioData)
        }
      }
      this.webSocket.send(JSON.stringify(params))
      this.handlerInterval = setInterval(() => {
        // websocket未连接
        if (this.webSocket.readyState !== 1) {
          this.audioData = []
          clearInterval(this.handlerInterval)
          return
        }
        if (this.audioData.length === 0) {
          if (this.status === 'end') {
            this.webSocket.send(
              JSON.stringify({
                data: {
                  status: 2,
                  format: 'audio/L16;rate=16000',
                  encoding: 'raw',
                  audio: ''
                }
              })
            )
            this.audioData = []
            clearInterval(this.handlerInterval)
          }
          return false
        }
        audioData = this.audioData.splice(0, 1280)
        // 中间帧
        this.webSocket.send(
          JSON.stringify({
            data: {
              status: 1,
              format: 'audio/L16;rate=16000',
              encoding: 'raw',
              audio: this.toBase64(audioData)
            }
          })
        )
      }, 40)
    }
  },
  mounted () {
    this.transWorker = transWorker
    this.transWorker.onmessage = event => {
      this.audioData.push(...event.data)
    }
    if (window.localStorage.getItem('nlp')) {
      this.nlpShow = true
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
.nlp-wrap {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1000;
  .nlp-start {
    font-size: 20px;
    width: 30px;
    height: 30px;
    background: lightgray;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    cursor: pointer;
    position: absolute;
    right: -50px;
    bottom: 0;
    transition: 0.3s;
    &.show {
      right: 0;
    }
  }
  .nlp-content {
    position: absolute;
    right: -360px;
    bottom: 0;
    transition: 0.3s;
    width: 340px;
    min-height: 80px;
    background: linear-gradient(
      to bottom,
      rgba(128, 128, 128, 0.8),
      rgba(0, 0, 0, 0.8)
    );
    border-radius: 6px;
    color: rgba(227, 227, 233, 1);
    &.show {
      right: 0;
    }
    .head {
      .close {
        margin: 10px;
        width: 12px;
        line-height: 12px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.4);
        font-size: 10px;
        text-align: center;
        cursor: pointer;
        color: #fff;
        i {
          transform: scale(0.8) translateY(0.5px);
        }
      }
    }
    .content {
      &.long {
        border-top: 1px solid rgba(255, 255, 255, 0.4);
        border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      }
      .title {
        margin: 10px 22px;
      }
      .says {
        margin: 10px 22px;
        max-height: 400px;
        overflow-y: auto;
        overflow-x: hidden;
        &::-webkit-scrollbar {
          width: 4px;
          background: rgba(177, 179, 176, 0);
        }
        &::-webkit-scrollbar-thumb {
          width: 4px;
          background: rgba(177, 179, 176, 1);
        }
        .say {
          font-size: 12px;
          color: rgba(177, 179, 176, 1);
          margin-left: 10px;
          margin-top: 10px;
        }
        .answer {
          font-size: 14px;
          color: rgba(227, 227, 233, 1);
          margin-top: 4px;
        }
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 22px;
      .donig {
        flex-shrink: 0;
        font-size: 18px;
        color: red;
        cursor: pointer;
        .active {
          animation: doing 1s linear infinite;
          color: #fff;
          box-shadow: none !important;
        }
      }
      .inp {
        margin-left: 12px;
        width: 1px;
        flex-grow: 1;
        input {
          width: 100%;
          background: rgba(227, 227, 233, 0.2);
          border: none;
          border-radius: 2px;
          padding: 4px 10px;
          line-height: 12px;
          color: rgba(227, 227, 233, 1);
          box-sizing: border-box;
        }
      }
    }
  }
}
@keyframes doing {
  0% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
</style>
